// Centralised FAQ content — easy to edit + reused for SEO/GEO.
// Each item shows up in the page UI AND in FAQPage JSON-LD for AI search engines.

export const HOME_FAQS = [
  {
    q: 'What is Bombay Bespoke Fashion House?',
    a: "Bombay Bespoke Fashion House LLC is a Dubai-based atelier offering bespoke men's tailoring and women's couture under two sub-brands — Bombay Bespoke (menswear) and VM by Vandana (women's design). Founded by Mr. Hardeep Singh Gill with three decades of craftsmanship, the house specialises in suits, shirts, kurtas, lehengas, gowns, saris and bespoke wedding wear.",
  },
  {
    q: 'Where is your shop located in Dubai?',
    a: 'You will find us at Arif and Bintoak Building, Ground Floor, Shop 8, Al Karama, Dubai, United Arab Emirates. Parking is available on the surrounding streets; the shop is a short drive from Downtown Dubai and Burj Khalifa.',
  },
  {
    q: 'Do you serve men, women, or both?',
    a: 'Both. The atelier houses two practices side by side: Bombay Bespoke for menswear (suits, sherwanis, shirts, kurtas, trousers) and VM by Vandana for women — lehengas, gowns, saris, resort wear and custom couture. Many couples choose us together for weddings.',
  },
  {
    q: 'How can I book a consultation?',
    a: "You can book a private consultation through the Book an Appointment page on this site, message us on WhatsApp at +971 54 279 1122, call the atelier, or email info@bombaybespokefashion.com. We'll confirm a time and prepare references and cloth ahead of your visit.",
  },
];

export const APPOINTMENT_FAQS = [
  {
    q: 'How long does a consultation take?',
    a: 'A first consultation is typically 45–60 minutes. We discuss the occasion, your preferences, take initial measurements, walk you through cloth options and agree on a design direction. Subsequent fittings are 20–30 minutes each.',
  },
  {
    q: 'Do I need an appointment, or can I walk in?',
    a: 'Walk-ins are welcome during shop hours (Mon–Sat, 10:00–21:00), but we strongly recommend booking an appointment so we can dedicate uninterrupted time, prepare cloth, and have either Mr. Gill or Mrs. Vandana available for you.',
  },
  {
    q: 'How far in advance should I book for a wedding?',
    a: 'For weddings we recommend booking at least 8–12 weeks in advance for menswear (suits, sherwanis) and 10–16 weeks for bridal couture (lehengas, gowns). For multi-event Indian weddings, please contact us as early as possible — three to six months ahead is ideal.',
  },
  {
    q: 'What should I bring to my first appointment?',
    a: "Bring any reference images or fabric swatches you love, and if possible, wear the kind of shoes you'll wear with the garment (heels for women's couture, dress shoes for suits) so the silhouette and length are accurate from the start.",
  },
  {
    q: 'Is there a consultation fee?',
    a: 'Consultations at the atelier are complimentary. A deposit is taken once your order is confirmed; the balance is due on final delivery.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept cash, all major debit/credit cards, and bank transfer (AED). For international clients, payment can be arranged remotely before shipping.',
  },
];

export const WOMENS_FAQS = [
  {
    q: 'How long does a bespoke lehenga take?',
    a: 'A fully bespoke bridal lehenga typically takes 6–12 weeks depending on embroidery density and the number of fittings. For heavily hand-worked pieces, please allow 12–16 weeks. We will give you a precise timeline at the consultation.',
  },
  {
    q: 'Can I bring my own design references?',
    a: 'Absolutely. Mrs. Vandana welcomes inspiration — Pinterest boards, magazine clippings, Instagram saves, a fabric you love, even a family heirloom you would like to echo. We translate references into a silhouette that flatters you, rather than copying.',
  },
  {
    q: 'Do you do custom design or only your collection?',
    a: 'Both. You can choose from existing pieces in the VM by Vandana boutique or commission an entirely custom design — sketched in front of you and tailored from scratch.',
  },
  {
    q: 'Do you ship internationally?',
    a: 'Yes. We ship globally to clients across the GCC, India, UK, US, Canada and Australia. Final fittings can be done in-store before you travel, or via video for remote orders with our digital measurement guide.',
  },
  {
    q: 'Do you alter existing garments?',
    a: "We accept alteration work selectively — primarily for our own clients and for couture pieces that warrant our craftsmanship. Please bring the garment in for assessment.",
  },
];

export const MENS_FAQS = [
  {
    q: 'How long does a bespoke suit take?',
    a: 'A bespoke two-piece suit takes 4–6 weeks from first measurement to final delivery, including two fittings. A three-piece or tuxedo adds about a week. Rush orders can sometimes be accommodated — please ask.',
  },
  {
    q: 'How many fittings will I need?',
    a: 'Two fittings is standard: a baste (skeleton) fitting after the first cut, and a forward fitting once the suit is mostly constructed. Complex pieces such as wedding sherwanis may include a third fitting for the embroidery placement.',
  },
  {
    q: 'Where do you source your fabrics?',
    a: "We work with the world's finest mills — Italian wool from Loro Piana, Vitale Barberis Canonico and Reda; British classics from Holland & Sherry and Dormeuil; Indian silks and brocades sourced directly for our wedding and occasion wear.",
  },
  {
    q: 'Do you make wedding sherwanis and Indo-Western?',
    a: 'Yes — sherwanis, achkans, bandhgalas, Jodhpuri suits, and Indo-Western fusion are a speciality of the house. We work closely with the bride\u2019s side to coordinate fabric, colour and embroidery across the wedding party.',
  },
  {
    q: 'Can I order remotely if I travel often?',
    a: 'Yes. Once we have a full block (your master pattern) on file, we can produce further suits and shirts without you being present. Many of our long-term clients reorder during their annual visits.',
  },
  {
    q: 'Do you make shirts and trousers individually?',
    a: 'Yes. Individual bespoke shirts, polos, and trousers are available — minimum orders may apply for first-time clients while we build your pattern.',
  },
];

export const CONTACT_FAQS = [
  {
    q: 'Where exactly is the shop?',
    a: 'Bombay Bespoke Fashion House is at Arif and Bintoak Building, Ground Floor, Shop 8, Al Karama, Dubai. Tap "Get Directions" above for Google Maps navigation.',
  },
  {
    q: 'What are your opening hours?',
    a: 'Mon–Sat, 10:00–21:00. Sunday is by appointment only — message us on WhatsApp and we will arrange a private viewing.',
  },
  {
    q: 'What is the fastest way to reach you?',
    a: 'WhatsApp is fastest — +971 54 279 1122 — and we reply within business hours. You can also call the same number, or email info@bombaybespokefashion.com.',
  },
  {
    q: 'Do you offer home or hotel consultations?',
    a: 'Yes, for select clients and ceremonial commissions we offer in-home or in-hotel consultations across Dubai and Abu Dhabi. Please WhatsApp us with the location and we will quote.',
  },
];
